import Questions from './Questions'

export { Questions }




// WEBPACK FOOTER //
// ./src/questions/components/index.js